import { rainHearts } from 'src/fancy/hearts-rain-css'

addEventListener('rainHearts', e => {
  const wave = () => rainHearts({ density: 0.5, color: e.detail })
  const interval = setInterval(wave, 100)
  setTimeout(() => clearInterval(interval), 5000)
  wave()
})
